import React, { useState, useEffect } from 'react';
import logo from '../assets/warals-logo.png';
import './NavBar.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from 'react-router-dom';

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const menuToggle = document.getElementById('navbarSupportedContent');

    const handleClick = (event) => {
      const target = event.currentTarget;

      // Skip collapse if it's the "Products" dropdown toggle
      if (target.classList.contains('dropdown-toggle')) return;

      const bsCollapse = new window.bootstrap.Collapse(menuToggle, {
        toggle: false
      });
      bsCollapse.hide();
      setIsOpen(false);
    };

    const clickableItems = document.querySelectorAll('.nav-link, .dropdown-item');

    clickableItems.forEach(link => {
      link.addEventListener('click', handleClick);
    });

    return () => {
      clickableItems.forEach(link => {
        link.removeEventListener('click', handleClick);
      });
    };
  }, []);

  const handleAboutClick = (e) => {
    if (window.location.pathname !== "/") {
      e.preventDefault();
      window.history.pushState({}, "", "/");
      window.dispatchEvent(new PopStateEvent("popstate"));
      // Delay scroll until homepage mounts
      setTimeout(() => {
        const el = document.getElementById("products");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100); // adjust delay if needed
    } else {
      const el = document.getElementById("products");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };



  return (
    <nav
      className="navbar navbar-expand-lg bg-body-tertiary"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1030,
        backgroundColor: 'white',
        padding: '0'
      }}
    >
      <div className="container-lg">
        <a className="navbar-brand" href="#">
          <img src={logo} alt="Logo"/>
        </a>

        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarSupportedContent"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
          onClick={() => setIsOpen(!isOpen)}
          style={{
            border: isOpen ? '1px solid rgba(0,0,0,.1)' : 'none',
            boxShadow: 'none'
          }}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarSupportedContent">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center gap-2">
            <li className="nav-item">
              <Link className="custom-underline nav-link" to="/" onClick={() => {
                if (window.location.pathname === "/") {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }}>Home</Link>
            </li>
            <li className="nav-item">
              <Link className="custom-underline nav-link" to="/#products" onClick={handleAboutClick}>About</Link>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Products
              </a>
              <ul className="dropdown-menu">
                <li><Link className="dropdown-item" to="/warals-school-management-system"
                 onClick={() => {
                    if (window.location.pathname === "/warals-school-management-system") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                >School Management System</Link></li>
                <li><Link className="dropdown-item" to="/warals-institute-management-system"
                  onClick={() => {
                    if (window.location.pathname === "/warals-institute-management-system") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                >Institute Management System</Link></li>
                
                <li><Link className="dropdown-item" to="/warals-learning-management-system"
                 onClick={() => {
                    if (window.location.pathname === "/warals-learning-management-system") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                >Learning Management System</Link></li>
                <li><Link className="dropdown-item" to="/warals-website-develop"
                 onClick={() => {
                    if (window.location.pathname === "/warals-website-develop") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
                >Website Development</Link></li>
              </ul>
            </li>
            <li className="nav-item">
              <Link className="custom-underline nav-link" to="/our-partners"
               onClick={() => {
                    if (window.location.pathname === "/our-partners") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
              >Partner With Us</Link>
            </li>
            <li className="nav-item">
              <Link className="custom-underline nav-link" to="/career"
               onClick={() => {
                    if (window.location.pathname === "/career") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
              >Career</Link>
            </li>
            <li className="nav-item">
              {/* <a className="custom-underline nav-link" href="https://blogs.warals.com/"
               onClick={() => {
                    if (window.location.pathname === "/blogSection") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
              >Blog</a> */}
            </li>
            <li className="nav-item">
              <Link className="custom-underline nav-link" to="/blogs.warals"
               onClick={() => {
                    if (window.location.pathname === "/blogs.warals") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
              >Blog</Link>
            </li>
            <li className="nav-item">
              <Link className="custom-underline nav-link" to="/contact-us"
               onClick={() => {
                    if (window.location.pathname === "/contact-us") {
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                  }}
              >Contact</Link>
            </li>
            <li className="nav-item">
              <a
                type="button"
                className="btn px-4 mx-3 btn-call-us"
                href="tel:+919871115060"
              >
                Call Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
